export enum Languages {
  ALLOW_REGISTRATION = 'Attender_AllowRegistration',
  DISALLOW_REGISTRATION = 'Attender_DisallowRegistration',
}

export enum Language {
  ENGLISH = 'english',
  DANISH = 'danish',
}
